"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var summaryTitleStyles = styles_1.makeStyles(function (_a) {
    var palette = _a.palette, typography = _a.typography;
    return ({
        title: {
            backgroundColor: palette.primary.main,
            color: palette.common.white,
            padding: '5px 15px',
            '& p': {
                fontSize: typography.fontLG,
            },
        },
        name: {},
        nameContent: {},
    });
}, { name: 'GqlSummary_SummaryTitle' });
exports.default = summaryTitleStyles;
